var iframeResize = require('./iframeResizer')

exports.iframeResize = iframeResize
exports.iframeResizer = iframeResize // Backwards compatability
exports.iframeResizerContentWindow = require('./iframeResizer.contentWindow')



//////////////////
// WEBPACK FOOTER
// ./~/iframe-resizer/js/index.js
// module id = 2309
// module chunks = 0